
import Vue, { PropType } from 'vue';
import { SubFilterOption } from '@/config/subFilters';

export default Vue.extend({
  name: 'GameTypeFilter',
  props: {
    filters: {
      type: Array as PropType<SubFilterOption[]>,
      required: true,
    },
    activeFilter: {
      type: String as PropType<string | null>,
      default: null,
    },
    showChips: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dropdownOpen: false,
    };
  },
  computed: {
    filterIcon(): string {
      return require('@/assets/famicons_filter.svg');
    },
  },
  methods: {
    toggle(value: string) {
      this.$emit('filter-changed', this.activeFilter === value ? null : value);
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    toggleFromDropdown(value: string) {
      this.$emit('filter-changed', this.activeFilter === value ? null : value);
      this.dropdownOpen = false;
    },
    handleOutsideClick(e: MouseEvent) {
      const wrapper = this.$refs.wrapper as HTMLElement;
      if (wrapper && !wrapper.contains(e.target as Node)) {
        this.dropdownOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
});
